module.exports = __webpack_public_path__ + "img/header-memoireRingsRosegold.a314e6e.webp";